const API_URL = "https://ims.holdthechild.net"; // Update with your actual API URL
export const getToken = () => localStorage.getItem("token");



export const fetchLogs = async (page = 1, limit = 10, search = "") => {
  try {
    const token = localStorage.getItem("token");

    // 1. Construct the query string with dynamic parameters
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      // Only include search if it has a value
      ...(search && { search }),
    }).toString();
    

    // NOTE: Changed endpoint from /api/logs/get to /api/admin/auth-logs (as suggested in controller logic)
    const url = `${API_URL}/api/logs/get-auth?${queryParams}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({ message: 'Server error' }));
      throw new Error(errorBody.message || "Failed to fetch activity logs");
    }

    const json = await response.json();

    // 3. Handle the new expected structure: 
    // { status: 'success', data: { logs: [...], totalPages: N, currentPage: M, totalResults: R } }
    
    if (json.data && Array.isArray(json.data.logs)) {
      return json.data; 
    } else {
      console.warn("Unexpected logs response structure:", json);
      // Return a standard empty structure to prevent crashes
      return { logs: [], totalPages: 1, currentPage: 1, totalResults: 0 };
    }

  } catch (error) {
    console.error("Error fetching logs:", error.message);
    // 4. Return an empty structure on error
    return { logs: [], totalPages: 1, currentPage: 1, totalResults: 0 };
  }
};
